import axios from 'axios'
import { map, sortBy } from 'lodash'
import humanizeDuration from 'humanize-duration'

import * as Types from '@/store/types'

export default
{
	state:
	{
		notificationTypes:   null,
		portLagInterfaces:   null,
		ticketSupportAreas:  null,
		ticketIncidentTypes: null,
		zoneRecordTypes:     null,
		zoneSOAs:            null,
		ismCommands:         null,
		ismSources:          null,
	},

	getters:
	{
	},

	mutations:
	{
        [Types.LOAD_NOTIFICATION_TYPES](state, notificationTypes)
		{
            state.notificationTypes = notificationTypes
        },

        [Types.LOAD_PORT_LAG_INTERFACES](state, portLagInterfaces)
		{
            state.portLagInterfaces = portLagInterfaces
        },

        [Types.LOAD_TICKET_SUPPORT_AREAS](state, ticketSupportAreas)
		{
            state.ticketSupportAreas = ticketSupportAreas
        },

        [Types.LOAD_TICKET_INCIDENT_TYPES](state, ticketIncidentTypes)
		{
            state.ticketIncidentTypes = ticketIncidentTypes
        },

        [Types.LOAD_ZONE_RECORD_TYPES](state, zoneRecordTypes)
		{
            state.zoneRecordTypes = zoneRecordTypes
        },

        [Types.LOAD_ZONE_SOAS](state, zoneSOAs)
		{
            state.zoneSOAs = map
			(
				zoneSOAs,
				entry =>
				{
					entry.humanizedLabel = humanizeDuration(entry.caching * 1000)

					return entry
				}
			)
        },

		[Types.LOAD_ISM_COMMANDS](state, ismCommands)
		{
			state.ismCommands = ismCommands
		},

		[Types.LOAD_ISM_SOURCES](state, ismSources)
		{
			state.ismSources = ismSources
		},
	},

	actions:
	{
		[Types.LOAD_ALL_LOOKUPS]({ dispatch })
		{
			return Promise.all
			([
				dispatch(Types.LOAD_NOTIFICATION_TYPES),
				dispatch(Types.LOAD_PORT_LAG_INTERFACES),
				dispatch(Types.LOAD_TICKET_SUPPORT_AREAS),
				dispatch(Types.LOAD_TICKET_INCIDENT_TYPES),
				dispatch(Types.LOAD_ZONE_RECORD_TYPES),
				dispatch(Types.LOAD_ZONE_SOAS),
				dispatch(Types.LOAD_ISM_COMMANDS),
				dispatch(Types.LOAD_ISM_SOURCES),
			])
			.catch(error => console.log(error))
		},

		[Types.LOAD_NOTIFICATION_TYPES]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/notification-types')
						.then
						(
							response =>
							{
								commit(Types.LOAD_NOTIFICATION_TYPES, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_PORT_LAG_INTERFACES]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/port-lag-interfaces')
						.then
						(
							response =>
							{
								commit(Types.LOAD_PORT_LAG_INTERFACES, response.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_TICKET_SUPPORT_AREAS]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/ticket-support-areas')
						.then
						(
							response =>
							{
								commit(Types.LOAD_TICKET_SUPPORT_AREAS, response.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_TICKET_INCIDENT_TYPES]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/ticket-incident-types')
						.then
						(
							response =>
							{
								commit(Types.LOAD_TICKET_INCIDENT_TYPES, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_ZONE_RECORD_TYPES]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/zone-record-types')
						.then
						(
							response =>
							{
								commit(Types.LOAD_ZONE_RECORD_TYPES, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_ZONE_SOAS]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/zone-soas')
						.then
						(
							response =>
							{
								commit(Types.LOAD_ZONE_SOAS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_ISM_SOURCES]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/ism-sources')
						.then
						(
							response =>
							{
								commit(Types.LOAD_ISM_SOURCES, sortBy(response.data, 'text'))
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.LOAD_ISM_COMMANDS]({ commit })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/lookup/ism-commands')
						.then
						(
							response =>
							{
								commit(Types.LOAD_ISM_COMMANDS, response.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},
	},
}